// extracted by mini-css-extract-plugin
export default {"button":"MultiSelectionDropDown_button__iVtut","displayRoles":"MultiSelectionDropDown_displayRoles__lRAun"};